export const isMailingAddressField = (field) => {
    return ["Mailing Address", 
            "Mailing City", 
            "Mailing State", 
            "Mailing Zip"].includes(field)
}

export const isTrustedContactField = (field) => {
    return field.toLowerCase().includes("trusted contact")
}

export const isFieldExisting = (clientInfos, formFieldName) => {
    return clientInfos.filter(info => info.formFieldName?.toLowerCase().trim() === formFieldName?.toLowerCase().trim())[0] ? true : false
}

export const getFormDataSetFieldValue = (formDataSet, formFieldName) => {
    return formDataSet?.filter(info => info.formFieldName?.toLowerCase().trim() === formFieldName?.toLowerCase().trim())[0]?.formFieldValue
}

export const updateFormDataSet = (value, name, infoFields) => {
    return infoFields.map(infoField => {
        let updatedInfoField = infoField
        if(infoField.formFieldName?.toLowerCase().trim() === name?.toLowerCase().trim() ) {
            updatedInfoField = {...infoField, formFieldValue: value}
        }
        return updatedInfoField
    })
}

export const formatSsnValue = (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d{3})(\d{1,2})/, '$1-$2')
    value = value.replace(/^(\d{3})-(\d{2})(.+)/, '$1-$2-$3')
    value = value.substring(0, 11)

    return value
}

export const formatDecimalValue = (value) => {
    value = value.replace(/[^\d.]/g, '')

    const parts = value.split('.')
    value = parts[0]

    if (parts.length > 1) {
        value += '.' + parts[1].substring(0, 2)
    }

    return value
}